export const getPermissions = (permissions) => {
    return permissions.map((p) => {
        return p.name
    });
}